import { useField } from "formik";
import React from "react";
import { Dropdown, Form, Label } from "semantic-ui-react";

interface Props {
    placeholder: string;
    name: string;
    options: any;
    showRequired?: boolean;
    hidetitle?: string;
    className?: any;
    onChange?: (e:any, d:any) => void;
    disabled?: any;
    value?: string;
}

function SelectInput(props: Props) {
    const [field, meta, helpers] = useField(props.name);
    return (
        <Form.Field error={meta.touched && !!meta.error}>
            {props.hidetitle !== 'true' &&
                <label style={{paddingBottom: "10px"}}>{props.placeholder} {props.showRequired ? '*' : '' }</label>}
            <Dropdown
                id={props.name}
                fluid
                search
                selection
                options={props.options}
                placeholder={props.placeholder}
                disabled={props.disabled}
                onChange={(e, d) => {
                    helpers.setValue(d.value);
                    if (props.onChange)
                    {
                        props.onChange(e, d);
                    }
                }}
                value={field.value}
            />
            {meta.touched && meta.error ? (
                <Label basic color='red' pointing='above'>{meta.error}</Label>
            ) : null}
        </Form.Field>
    )
}

export default SelectInput;